import styled from 'styled-components';
import {getToken, getFontSize, getFontWeight, getPrimitive} from '@tickchak/react-share/app';
import {dFlexCenter, dFlexBetween, alignCenter} from '../../../../../globalVariables/GlobalFlex';

export const toolbarRow = styled.div`
    ${dFlexBetween};
    ${alignCenter};
    min-height: 32px;
    width: 100%;
`;

export const toolbarStart = styled.div`
    ${dFlexCenter};
`;

export const toolbarEnd = styled.div`
    ${dFlexCenter};
    gap: var(--space-sm);
    padding: var(--space-sm);
`;

export const charCounter = styled.span<{isExceeded: boolean}>`
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('regular')};
    color: ${p => p.isExceeded ? getPrimitive('reds.red400') : getToken('color.text.default')};
    white-space: nowrap;
`;

export const formatButton = styled.button`
    ${dFlexCenter};
    width: 28px;
    height: 28px;
    padding: 4px;
    border: none;
    border-radius: var(--border-radius-border-radius-sm);
    background: transparent;
    cursor: pointer;

    &:hover {
        background: ${getToken('color.bg.surface.default')};
    }
`;
